<template>
  <div class="text-builder-preview-wrapper">
    <div
      class="text-builder-preview-wrapper__status-bar flex-col align-end justify-center"
    >
      <div class="flex-row gap-2">
        <PhCellSignalFull size="16" weight="bold" />
        <PhWifiHigh size="16" weight="bold" />
        <PhBatteryMedium size="16" weight="bold" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import {
  PhBatteryMedium,
  PhCellSignalFull,
  PhWifiHigh,
} from '@phosphor-icons/vue'
</script>

<style lang="scss" scoped>
@use '@/styles/globals';

.text-builder-preview-wrapper {
  margin: 0 auto;
  width: min(100%, 380px);
  max-width: 380px;
  height: min(100%, 750px);
  min-height: 380px;
  border-radius: 50px;
  border: 8px solid var(--text-color-primary);
  background-color: var(--background-primary);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  $status-bar-height: 46px;
  &__status-bar {
    height: $status-bar-height;
    width: 100%;
    padding: 0 24px;
  }
  :deep(.builder-block-preview-wrapper) {
    display: flex;
    justify-content: flex-end;
  }

  :deep(.builder-preview) {
    /* Disable box-shadow here so we can use it one level up */
    box-shadow: none;
    /* Disable background-color to avoid overlapping the phone outline */
    background-color: initial;
    height: calc(100% - #{$status-bar-height});
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  // SMS-specific spacing for standalone block previews (ME1 SMS path)
  :deep(.standalone-block-preview) {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 20px;
  }
}
</style>
